// SEARCH FILTER TYPES
export const APPLY_FILTERS = 'jobOfferList/applySearchFilter'
export const HIDE_LIST_ALERT = 'jobOfferList/hideAlert'
export const SET_LIST_ALERT = 'jobOfferList/setAlertModal'
export const IS_LOADING = 'jobOfferList/isLoading'
export const SET_CONFIRM_MODAL = 'jobOfferList/setConfirmModal'
export const HIDE_CONFIRM_MODAL = 'jobOfferList/hideConfirmModal'
export const SHOW_CONFIRM_MODAL = 'jobOfferList/showConfirmModal'
export const RESET_FILTERS = 'jobOfferList/reset'
export const RESET_RESULTS = 'jobOfferList/resetTableData'
export const UPDATE_SEARCHLIST = 'jobOfferList/updateResults'
export const CHG_FILTER_DATA = 'jobOfferList/changeFilterField'
export const CHG_FILTER_PAGE = 'jobOfferList/changePage'
export const CHG_FILTER_PAGE_SIZE = 'jobOfferList/changePageSize'
export const CHG_FILTER_SORT = 'jobOfferList/changeSortModel'
export const CHG_SELECTED_ROWS = 'jobOfferList/changeSelected'

// ADD FORM TYPES
export const RESET_ADD_DATA = 'jobOfferAdd/reset'
export const UPD_ADD_ALERT = 'jobOfferAdd/updateAlert'
export const INSERT_LOADING = 'jobOfferAdd/isLoading'
export const CHG_FIELD = 'jobOfferAdd/changeField'
export const CHG_STATUS = 'jobOfferAdd/changeStatus'
export const SET_ADD_DATA = 'jobOfferAdd/setAddData'
export const HIDE_ADD_ALERT = 'jobOfferAdd/hideAlert'
export const HIDE_SHOW_MODAL = 'jobOfferAdd/hideModal'
export const HAS_ADD_LOADED = 'jobOfferAdd/hasAddLoaded'
export const UPDATE_INFO = 'jobOfferAdd/updateInfo'
export const SHOW_HIDE_CONFIRM_MODAL = 'jobOfferAdd/hideShowConfirmModal'
export const UPD_ADD_MODE = 'jobOfferAdd/changeMode'